<script setup lang="ts">
</script>

<template>
  <div class="rr-menu" role="menu">
    <slot />
  </div>
</template>

<style scoped>
.rr-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100%;
}
</style>
